import React from 'react'

interface LabelProps {
  htmlFor: string
  label: string
}

const Label: React.FC<LabelProps> = ({ htmlFor, label }) => {
  return (
    <label
      htmlFor={htmlFor}
      className="block text-sm font-medium leading-6 text-gray-900"
    >
      {label}
    </label>
  )
}

export default Label
